import { BotsMatchType } from '@colonist/game-base-types';
const INTERNAL_AD_1_DURATION_MS = 13000;
const INTERNAL_AD_2_DURATION_MS = 12600;
const INTERNAL_AD_3_DURATION_MS = 13000;
const RUSH_QUEUE_AD_DURATION_MS = 11000;
const COLONIST_RUSH_AD_DURATION_MS = 14800;
const COLONIST_RUSH_AD_2_DURATION_MS = 15000;
const INTERNAL_VIDEO_ADS = [
    {
        loadImage: async ()=>{
            const { default: url } = await import('@static/images/internal_video_ad/internal_ad_1.gif');
            return url;
        },
        durationMs: INTERNAL_AD_1_DURATION_MS
    },
    {
        loadImage: async ()=>{
            const { default: url } = await import('@static/images/internal_video_ad/internal_ad_2.gif');
            return url;
        },
        durationMs: INTERNAL_AD_2_DURATION_MS
    },
    {
        loadImage: async ()=>{
            const { default: url } = await import('@static/images/internal_video_ad/internal_ad_3.gif');
            return url;
        },
        durationMs: INTERNAL_AD_3_DURATION_MS
    },
    {
        loadImage: async ()=>{
            const { default: url } = await import('@static/images/internal_video_ad/rush_queue_ad.gif');
            return url;
        },
        durationMs: RUSH_QUEUE_AD_DURATION_MS
    },
    {
        loadImage: async ()=>{
            const { default: url } = await import('@static/images/internal_video_ad/colonist_rush_ad.gif');
            return url;
        },
        durationMs: COLONIST_RUSH_AD_DURATION_MS,
        matchTypes: [
            BotsMatchType.ColonistRush
        ]
    },
    {
        loadImage: async ()=>{
            const { default: url } = await import('@static/images/internal_video_ad/colonist_rush_ad_2.gif');
            return url;
        },
        durationMs: COLONIST_RUSH_AD_2_DURATION_MS,
        matchTypes: [
            BotsMatchType.ColonistRush
        ]
    }
];
export function selectInternalVideoAdToShow(matchType) {
    const specificAds = INTERNAL_VIDEO_ADS.filter((ad)=>{
        var _ad_matchTypes;
        return (_ad_matchTypes = ad.matchTypes) === null || _ad_matchTypes === void 0 ? void 0 : _ad_matchTypes.includes(matchType);
    });
    const eligibleAds = specificAds.length > 0 ? specificAds : INTERNAL_VIDEO_ADS.filter((ad)=>ad.matchTypes == undefined);
    if (eligibleAds.length == 0) return undefined;
    return eligibleAds[Math.floor(Math.random() * eligibleAds.length)];
}
